import { render, staticRenderFns } from "./DigitalContact.vue?vue&type=template&id=c0b1e128&scoped=true"
import script from "./DigitalContact.vue?vue&type=script&lang=js"
export * from "./DigitalContact.vue?vue&type=script&lang=js"
import style0 from "./DigitalContact.vue?vue&type=style&index=0&id=c0b1e128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b1e128",
  null
  
)

export default component.exports